<template>
  <div>
    <Header />
    <router-view />
  </div>
</template>

<script>
import { useCustomValidationRules } from "./composables/useCustomValidationRules.js";
import Header from "./components/Header/Header.vue";

export default {
  name: "App",
  components: {
    Header,
  },
  setup() {
    useCustomValidationRules();
    return {};
  },
};
</script>

<style></style>